import { render, staticRenderFns } from "./campaign-partner.vue?vue&type=template&id=42d9f1ba"
import script from "./campaign-partner.vue?vue&type=script&lang=js"
export * from "./campaign-partner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports